import type { CitationAttrs } from '$lib/markdown/types';

export function citationHash(attrs: CitationAttrs): string {
	const type = attrs.webId != null ? 'web' : attrs.chunkId != null ? 'chunk' : 'document';
	const id = attrs.webId ?? attrs.chunkId ?? attrs.docId ?? 'unknown';
	const raw = `${type}:${id}:${attrs.quote ?? ''}`;
	let h = 5381;
	for (let i = 0; i < raw.length; i++) {
		h = (((h << 5) + h) ^ raw.charCodeAt(i)) | 0;
	}
	return (h >>> 0).toString(36);
}
